import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";


export const Route = createFileRoute("/laadpaal-installeren-stappenplan")({
  head: () => ({
    meta: [
      { title: "Laadpaal thuis installeren: stappenplan | Elvion Group" },
      {
        name: "description",
        content:
          "Stappenplan laadpaal thuis installeren: meterkast check, keuze laadpaal en installatie. Praktische voorbereiding door een erkende installateur.",
      },
      { property: "og:title", content: "Laadpaal thuis installeren: stappenplan | Elvion Group" },
      {
        property: "og:description",
        content:
          "Van meterkast-check tot oplevering. Wat kunt u verwachten bij het installeren van een laadpaal thuis?",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://elvion-group.nl/laadpaal-installeren-stappenplan" },
    ],
    links: [
      { rel: "canonical", href: "https://elvion-group.nl/laadpaal-installeren-stappenplan" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "HowTo",
          name: "Laadpaal thuis installeren",
          description:
            "Stappenplan om een laadpaal thuis te laten installeren door een erkende installateur.",
          step: [
            { "@type": "HowToStep", name: "Meterkast controleren", text: "Controleer of uw meterkast (1- of 3-fase) geschikt is voor een laadpaal en of er ruimte is voor een extra groep." },
            { "@type": "HowToStep", name: "Kies de juiste laadpaal", text: "Bepaal het gewenste laadvermogen (3,7 – 22 kW), aansluiting en of u een vaste kabel of type 2-socket wilt." },
            { "@type": "HowToStep", name: "Kabeltracé bepalen", text: "Meet de route van meterkast naar de plek waar de laadpaal komt en bespreek doorvoeringen of graafwerk." },
            { "@type": "HowToStep", name: "Installatie", text: "De monteur installeert een aparte groep met aardlekautomaat, legt de kabel en monteert de laadpaal volgens NEN 1010." },
            { "@type": "HowToStep", name: "Oplevering en test", text: "De installatie wordt getest, ingemeten en opgeleverd inclusief garantie en meetrapport." },
          ],
        }),
      },
    ],
  }),
  component: LaadpaalStappenplanPage,
});

function LaadpaalStappenplanPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-16">
        <article className="prose prose-slate max-w-none">
          <h1>Laadpaal thuis installeren: stappenplan</h1>
          <p className="lead">
            Overweegt u een laadpaal thuis? Hieronder leest u wat u kunt
            verwachten en hoe u zich voorbereidt op een vlotte installatie
            door een erkende installateur.
          </p>

          <h2>1. Controleer uw meterkast</h2>
          <p>
            De eerste stap is een korte meterkast-check: heeft u een 1-fase
            of 3-fase aansluiting, en is er ruimte voor een extra groep met
            aardlekautomaat? Bij twijfel kan een installateur dit ter plekke
            of aan de hand van foto&apos;s beoordelen.
          </p>

          <h2>2. Kies de juiste laadpaal</h2>
          <p>
            Op basis van uw auto, jaarkilometrage en aansluiting bepaalt u
            het gewenste laadvermogen (3,7 – 22 kW). Kies vervolgens tussen
            een vaste kabel of een type 2-socket, en of u een dynamische
            load-balancer wilt om overbelasting te voorkomen.
          </p>

          <h2>3. Bepaal het kabeltracé</h2>
          <p>
            Meet de route van de meterkast naar de gewenste plek van de
            laadpaal. Doorvoeringen door muren, kruipruimte of tuin bepalen
            grotendeels de installatietijd. Onze monteur neemt dit tijdens
            de intake met u door.
          </p>

          <h2>4. De installatie</h2>
          <p>
            Op de afgesproken dag installeert een gecertificeerde monteur
            een aparte groep in de meterkast, legt de kabel netjes weg en
            monteert de laadpaal conform NEN 1010. De meeste installaties
            zijn binnen een halve dag klaar.
          </p>

          <h2>5. Oplevering</h2>
          <p>
            Na een korte test krijgt u het meetrapport, een korte uitleg van
            de app of pas, en garantie op zowel de laadpaal als de
            installatie.
          </p>

          <h2>Klaar om te starten?</h2>
          <p>
            Vraag vrijblijvend een{" "}
            <Link to="/laadpaal-installateur" className="text-primary underline">
              offerte voor laadpaal-installatie
            </Link>{" "}
            aan of{" "}
            <Link to="/klantenservice" className="text-primary underline">
              neem contact op
            </Link>{" "}
            met een adviseur.
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
